import React from 'react'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Modal, useMediaQuery } from '@material-ui/core'
import { useCarouselModalStyles } from './carousel-modal.styles'
import { theme } from '@plandi/common'

SwiperCore.use([Navigation, Pagination])

type CarouselModalProps = {
  isOpen: boolean
  onClose: (type: string) => void
  activeIndex?: number
  images?: string[]
  tab?: string
}

export const CarouselModal: React.FC<CarouselModalProps> = (props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down(960))
  const classes = useCarouselModalStyles()

  return (
    <Modal
      open={props.isOpen}
      onClose={() => props.onClose(props.tab ? props.tab : '')}
    >
      <Swiper
        pagination={false}
        navigation={isMobile ? false : true}
        spaceBetween={50}
        className={classes.swiperContainer}
        centeredSlides
        initialSlide={props.activeIndex}
        watchOverflow
      >
        {props.images?.map((image, idx) => (
          <SwiperSlide key={idx}>
            <div className={classes.sliderZoomContainer}>
              {isMobile ? (
                <div style={{ position: 'relative' }}>
                  <img
                    src={image}
                    alt={`slide ${idx}`}
                    className={classes.img}
                  />
                  <IconButton
                    className={classes.closeButton}
                    onClick={() => props.onClose(props.tab ?? '')}
                  >
                    <CloseIcon htmlColor="#fff" className={classes.closeIcon} />
                  </IconButton>
                </div>
              ) : (
                <img src={image} alt={`slide ${idx}`} className={classes.img} />
              )}
            </div>
          </SwiperSlide>
        ))}
        {!isMobile && (
          <IconButton
            className={classes.closeButton}
            onClick={() => props.onClose(props.tab ?? '')}
          >
            <CloseIcon htmlColor="#fff" className={classes.closeIcon} />
          </IconButton>
        )}
      </Swiper>
    </Modal>
  )
}
